import apiClient from "../../../utils/lib/apiClient";
import { loadingState, loadingText } from "../../../states/loadingState";
import { useSetRecoilState } from "recoil";
export const useGetSupplierInfo = () => {
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);

  const getSupplierInfo = async (supplier: string) => {
    const searchId = String(Number(supplier)).padStart(5, "0");
    setLoadingAnimation(true);
    setLoadingText("検索中...");
    try {
      const res = await apiClient.get(`/siteDiary/supplier-info/${searchId}`);

      const data = res.data;
      if (data[0] !== "") return res.data;

      return null;
    } catch (e) {
      window.alert(`エラーが発生しました${e}`);
      return null;
    } finally {
      setLoadingAnimation(false);
      setLoadingText("");
    }
  };

  return getSupplierInfo;
};
